import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReset } from 'react-hook-form';

import { getUser } from '../api';
import { usersQueryKeys } from '../data';
import { setUserFormInitialValues } from '../store';
import { UserDetails } from '../types';

import { UserDetailsForm } from './use-user-details.form';

type UseGetUserProps = {
  reset: UseFormReset<UserDetailsForm>;
  user: UserDetails;
  open: boolean;
};

export const useGetUser = ({ reset, user, open }: UseGetUserProps) => {
  const userQuery = useQuery({
    queryKey: [...usersQueryKeys.getUser, user?.uuid],
    queryFn: () => getUser({ uuid: user?.uuid }),
    enabled: open && !!user?.uuid,
  });

  useEffect(() => {
    if (
      userQuery.isError ||
      userQuery.isFetched === false ||
      userQuery.data === undefined
    )
      return;
    if (userQuery.isSuccess) setUserFormInitialValues(userQuery.data);
    reset(userQuery.data);
  }, [
    open,
    userQuery.isSuccess,
    userQuery.isError,
    userQuery.isFetched,
    userQuery.data,
    reset,
  ]);

  return userQuery;
};
